<template>
  <div class="tresult">
      <h3 class="tresult__title">Работы студентов</h3>
        <ul class="tresult__list">
            <div class="tresult-item-content header-row">
                <div v-if="!mobileMode">
                </div>
                <div v-if="!mobileMode" class="tresult__quantity">  
                </div>
                <span class="tresult__name header-col">
                    <el-input @input="filtred()" class="serch-input" @clear="sortElements(disciplines)" :clearable="true" v-model="filterValue" placeholder="Поиск"></el-input>
                </span>
                <div v-if="!mobileMode" class="tresult__quantity-done">
                    <span>Проверено</span> / <span>Прислано</span>
                </div>
            </div>
            <router-link :to="'/tresult/view/'+ discipline.disciplineId" class="tresult__item" 
                v-for="(discipline, index) in filtredArray"
                :key="index">
                <div class="tresult-item-content">
                    <i class="el-icon-arrow-left bottom-icon" ></i>
                    <div class="tresult__quantity" :style="{backgroundColor : colorRound(discipline.countUncheckedWorks)}">
                        <span>{{discipline.countUncheckedWorks}}</span>
                    </div>
                    <span class="tresult__name">{{discipline.disciplineName}}</span>
                    <div class="tresult__quantity-done">
                        <span class="quantity__sent">{{discipline.countWorks - discipline.countUncheckedWorks}}</span>/<span class="sent">{{discipline.countWorks}}</span>
                    </div>
                </div>
            </router-link>
      </ul>
  </div>
</template>

<script>

import {mapActions} from 'vuex'
export default {
    data() {
        return {
            filterValue:'',
            disciplines:[],
            filtredArray:[]
        }
    },
    computed:{
        mobileMode(){
            return this.$store.state.mobileMode
        }
    },
    methods: {
        ...mapActions(['tresultFetchDiscipLines']),
        colorRound(value){
            return value ? '#E6A23C' : '#C0C4CC'
        },
        filtred(){
            this.filtredArray = this.disciplines.filter(el=>el.disciplineName.toLowerCase().match(this.filterValue.toLowerCase()))
        },
        sortElements(array){
            array.sort((a,b)=>{
                return b.countUncheckedWorks - a.countUncheckedWorks
            })
            this.filtredArray = array
        }
    },

    mounted() {
        this.tresultFetchDiscipLines('api/results').then(res=>{
            
            this.disciplines = res.data.uncheckedWorksForDisciplines
            this.filtredArray = this.disciplines
            this.sortElements(this.filtredArray)
        })
    },

}
</script>

<style lang="scss">
    .tresult{
        width: 100%;
        height: 100%;
        .tresult__title{
            width: 100%;
        }
        .header-col{
            width: 100%;
        }
        .serch-input{
            width: 100%;
            max-width: 500px;
            .el-input__suffix{
                i{
                    font-size: 20px;
                }
            }
        }
        .tresult__list{
            display: grid;
            grid-template-rows: repeat(auto-fill, 1fr);
            width: max-content;
            max-width: 100%;
            overflow: hidden;

        }   
        .tresult__item{
            background-color: $basic-white;
            cursor: pointer;
            border-bottom: 1px solid $base-border-clr;
        }
        .tresult__item:first-child{
            border-top: 1px solid $base-border-clr;
        }
        .ativeItems{
            background-color: $brand-clr-1;
            color: $basic-white;
            &:hover{
                background-color: $brand-clr-1;
            }
        }
        .tresult-item-content{
            position: relative;
            z-index: 5;
            padding: 15px;
            display: grid;
            column-gap: 5px;
            grid-template-columns: 30px 30px 3fr 1fr;
            align-items: center;
            justify-items: center;
            transition-property: background-color;
            transition-duration: 0.3s;
            &:hover{
                background-color: $extra-light-border;
            }
        }
        .header-row{
            &:hover{
                background-color: $basic-white;
            }
        }
        .tresult__quantity{
            display: flex;
            flex-shrink: 0;
            justify-content: center;
            align-items: center;
            color: $basic-white;
            border-radius: 50%;
            width: 25px;
            height: 25px;
            font-size: 14px;
        }
        .tresult__quantity-done{
            white-space: nowrap;
            justify-self: center;
            color: $secondary-text-clr;
        }
        .tresult__name{
            display: flex;
            align-items: center;
            justify-self: start;
        }
    }
     @media (max-width: 800px){
         .tresult{
            .tresult__list{
                align-items: center;
                width: 100%;
                grid-template-rows: repeat(auto-fill, minmax(30px, 1fr));
            }
            .tresult__item{
                 //margin-bottom: 20px;
            }
            .tresult-item-content{
                padding: 10px 0;
                grid-template-columns: max-content max-content 4fr 1fr;
               
            }
            .header-row{
                grid-template-columns: 1fr;
            }
         }
     }
</style>